var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C6.2733 0 0 6.2733 0 14C0 21.7267 6.2733 28 14 28C21.7267 28 28 21.7267 28 14C28 6.2733 21.7267 0 14 0ZM14 1.95349C20.6484 1.95349 26.0465 7.35163 26.0465 14C26.0465 20.6484 20.6484 26.0465 14 26.0465C7.35163 26.0465 1.95349 20.6484 1.95349 14C1.95349 7.35163 7.35163 1.95349 14 1.95349Z",
    fill: "#F59E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6279 8.79071V19.2093C15.6279 19.7485 16.0655 20.1861 16.6047 20.1861C17.1438 20.1861 17.5814 19.7485 17.5814 19.2093V8.79071C17.5814 8.25155 17.1438 7.81396 16.6047 7.81396C16.0655 7.81396 15.6279 8.25155 15.6279 8.79071Z",
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4185 8.79071V19.2093C10.4185 19.7485 10.856 20.1861 11.3952 20.1861C11.9344 20.1861 12.3719 19.7485 12.3719 19.2093V8.79071C12.3719 8.25155 11.9344 7.81396 11.3952 7.81396C10.856 7.81396 10.4185 8.25155 10.4185 8.79071Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldIcon);
export default __webpack_public_path__ + "static/media/HoldIcon.67794772d52bedb7a3929945ea15bd2f.svg";
export { ForwardRef as ReactComponent };